module.exports = __webpack_public_path__ + "img/activebasicdetail.e3e93bb2.svg";